import { Injectable } from "@angular/core";
import { FetchStatusSelector, FetchStatusType } from "@obg/ngrx-utils";
import { CommonState } from "@obg/ngx.common";

import { RegistrationFeatureState } from "../state";

import { ACTION_PREFIX, SEAMLESS_REGISTRATION_ACTION_TYPE } from "./seamless-registration.action";
import {
	CustomerRegistrationStatus,
	SeamlessRegistrationState,
	SeamlessRegistrationStatus,
} from "./seamless-registration.model";

@Injectable({
	providedIn: "root",
})
export class SeamlessRegistrationSelector {
	getState() {
		return (state: RegistrationFeatureState): SeamlessRegistrationState =>
			state.registrationFeature.seamlessRegistration;
	}

	getRegistrationReference() {
		return (state: RegistrationFeatureState): string | undefined =>
			state.registrationFeature.seamlessRegistration.registrationReference;
	}

	getCustomerReference() {
		return (state: RegistrationFeatureState): string | undefined =>
			state.registrationFeature.seamlessRegistration.customerReference;
	}

	getProviderUrl() {
		return (state: RegistrationFeatureState): string | undefined =>
			state.registrationFeature.seamlessRegistration.providerUrl;
	}

	getRegistrationStatus() {
		return (state: RegistrationFeatureState): SeamlessRegistrationStatus | undefined =>
			state.registrationFeature.seamlessRegistration.status;
	}

	getCustomerRegistrationStatus() {
		return (state: RegistrationFeatureState): CustomerRegistrationStatus | undefined =>
			state.registrationFeature.seamlessRegistration.customerRegistrationStatus;
	}

	isBusy() {
		return (state: CommonState): boolean => FetchStatusSelector.isBusy(ACTION_PREFIX)(state);
	}

	isAttachBonusSuccess() {
		return (state: CommonState): boolean =>
			FetchStatusSelector.isStatus(SEAMLESS_REGISTRATION_ACTION_TYPE.attachBonus, FetchStatusType.Success)(state);
	}

	isAttachBonusFailed() {
		return (state: CommonState): boolean =>
			FetchStatusSelector.isStatus(SEAMLESS_REGISTRATION_ACTION_TYPE.attachBonus, FetchStatusType.Fail)(state);
	}
}
